import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

const CarPositionIconHorizontal = ({ width = 43, height = 55, color = 'currentColor', ...props }: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 43 55" fill="none" {...props}>
            <path d="M21.7769 0.00689697C33.2474 0.289453 42.4565 9.4123 42.4565 20.6251C42.4565 33.8918 25.4643 50.9353 21.8853 54.378C21.5102 54.7387 20.9468 54.7387 20.5718 54.378C16.9926 50.9352 0.000488281 33.8917 0.000488281 20.6251C0.000488281 9.23419 9.50506 6.10352e-05 21.229 6.10352e-05L21.7769 0.00689697ZM21.229 2.00006C10.5549 2.00006 2.00049 10.3927 2.00049 20.6251C2.00049 23.5375 2.93995 26.7886 4.52197 30.1631C6.09654 33.5217 8.25287 36.8868 10.5522 39.9962C14.6227 45.5005 19.0483 50.0747 21.228 52.2237C23.4076 50.075 27.834 45.501 31.9048 39.9962C34.2042 36.8868 36.3605 33.5217 37.9351 30.1631C39.5171 26.7886 40.4565 23.5375 40.4565 20.6251C40.4565 10.3928 31.9029 2.00029 21.229 2.00006ZM23.2915 16.2628C26.4205 16.2628 28.395 18.0903 28.395 21.1143C28.3949 24.1591 26.4624 25.9444 23.2495 25.9444H20.3726V30.963H17.2651V16.2628H23.2915ZM20.3726 23.088H23.2075C24.4465 23.088 25.2866 22.3318 25.2866 21.0928C25.2866 19.749 24.5728 19.0978 23.229 19.0977H20.3726V23.088Z" fill={color} />
        </svg>
    );
};

export default CarPositionIconHorizontal;
